<template>
    <div class="image-gallery">
        <LargeImage :data="cLargeItem" @on-image-click="handleClick"></LargeImage>
        <SmallImages :data="cSmallItems" @onImageClick="handleClick"></SmallImages>
        <Teleport to="body">
            <LightBox
                v-if="showLightbox"
                :slides="items"
                :activeIndex="activeIndex"
                @onClose="showLightbox = false"></LightBox>
        </Teleport>
    </div>
</template>

<script setup lang="ts">
// Vue
import { computed, ref } from 'vue';

// Components
import LargeImage from './components/LargeImage.vue';
import SmallImages from './components/SmallImage.vue';
import LightBox from './components/LightBox.component.vue';

// Model
import { IGalleryItem } from './model';

const activeIndex = ref<number>(0);
const showLightbox = ref<boolean>(false);

const props = defineProps<{
    items: IGalleryItem[];
}>();

function handleClick(image: string, index: number) {
    showLightbox.value = true;
    activeIndex.value = index;
}

const cAllItems = computed(() => {
    return props.items;
});

const cLargeItem = computed(() => {
    return props.items[0];
});

const cSmallItems = computed(() => {
    return props.items.slice(1, 3);
});
</script>
